<template>
  <div class="report-page">
    <div id="ok-signal"><span v-if="dataURI">OK</span></div>
    <div id="data-uri">
      {{ dataURI }}
    </div>
    <div class="reports-container">
      <Report class="report" v-if="ready" />
    </div>
    <div class="error">
      {{ error }}
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import domtoimage from 'dom-to-image';
import jsPDF from 'jspdf';
import Report from '../components/overview/report/Report.vue';
export default {
  data() {
    return {
      dataURI: '',
      memberId: null,
      originAS: null,
      reportPeriod: null,
      error: null,
      ready: false
    };
  },
  created() {
    const { memberId, originAS, reportPeriod } = this.$route.query;
    if (memberId && originAS && reportPeriod) {
      this.$store.dispatch('dataStore/fetchMetaData');
      this.memberId = memberId;
      this.originAS = originAS;
      this.reportPeriod = reportPeriod;
    } else {
      this.error = 'parameters are missing';
    }
  },
  computed: {
    ...mapGetters('dataStore', [
      'metaDataFetched',
      'selectedAccount',
      'selectedASN',
      'accumulativeStatsData'
    ])
  },
  watch: {
    metaDataFetched(val) {
      if (val) {
        this.selectAccount(this.memberId);
      }
    },
    selectedAccount(val) {
      if (val && val.id === this.memberId) {
        this.selectASN(this.originAS);
      }
    },
    selectedASN(val) {
      if (val && val.id === this.originAS) {
        if (this.reportPeriod === '60') {
          this.changeMonth('last');
        }
        this.ready = true;

        // set the timeout as 5s, which is 1s before, because the charts need a while for rendering. This change is for the recurring report.
        // Given the recurring report job might retrieve multiple report at the same time, so set the timer longer. It won't affect any user experience, as this will be run in backend.
        setTimeout(() => {
          this.generate();
        }, 5000);
      }
    }
  },
  methods: {
    ...mapActions('dataStore', ['selectAccount', 'selectASN', 'changeMonth']),
    generate() {
      const statusData = this.accumulativeStatsData;
      if (process.env.VUE_APP_REPORT_MODE && !statusData) {
        // throw error for recurring-report-generator to catch when statusData is null
        throw 'Generate PDF failed due to empty data';
      }

      const element = this.$el.getElementsByClassName('report')[0];
      domtoimage.toPng(element).then(blob => {
        const doc = new jsPDF({
          orientation: 'p',
          unit: 'px',
          format: 'a4',
          compress: true
        });
        const margin = 2;
        const width = doc.internal.pageSize.getWidth() - margin;
        const height = doc.internal.pageSize.getHeight() - margin;
        doc.addImage(blob, 'png', margin, margin, width, height);
        this.dataURI = doc.output('datauristring');
      });
    }
  },
  components: {
    Report
  }
};
</script>

<style lang="scss" scoped>
.reports-container {
  position: fixed;
  background: white;
  left: 100vw;
}
</style>
